import { createFileRoute } from "@tanstack/react-router";
import { ManageAmenitiesPage } from "@/components/pages/ManageAmenitiesPage";

export const Route = createFileRoute("/amenities/manage")({
  component: ManageAmenitiesPage,
});
